import axios from "axios";

// Custom cinfigurated instance
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export default instance;
